export const OPTION_PANEL_TEST_IDS = {
  SEARCH_BTN: 'option-panel-search-btn',
  CONFIRM_BTN_MOBILE: 'option-panel-confirm-btn-mobile',
  GROUP_LIST: 'option-group-list',
  SUBGROUP_LIST: 'option-subgroup-list',
  ADD_ADDITIONAL_PRODUCT_MODAL: 'add-additional-product-modal',
  SECTION_CHANGE_STYLE_PRESET_MODAL: 'section-change-style-preset-modal',
  GROUP_NAV: 'option-group-nav',
  ITEM_COUNT_LABEL: 'option-panel-item-count',
} as const;

